import { render, staticRenderFns } from "./Anonymous.vue?vue&type=template&id=a04c358c"
import script from "./Anonymous.vue?vue&type=script&lang=js"
export * from "./Anonymous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports